import React from 'react';
import NextButton from './NextButton';

const SecondClue: React.FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <p>Head back upstairs and look under the flowers for your next clue. </p>
      <img src='flowers.jpg' style={{ width: '100%' }} />
      <NextButton
        prompt='Enter the answer to the clue:'
        acceptedClues={['May 3', '5/3', 'May 3 2021', '5/3/21']}
      />
    </div>
  );
};

export default SecondClue;
